import { Component, OnInit } from '@angular/core';
import { StartUpConfigUiService } from '../../../Core/Services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {

  constructor(private startUpConfigUiService: StartUpConfigUiService) { }

  preloaderImageUrl: string;

  ngOnInit(): void {
    this.startUpConfigUiService.getPreloaderImageUrl()
      .pipe(take(1))
      .subscribe({
        next: (preloaderImageUrl) => {
          this.preloaderImageUrl = preloaderImageUrl;
        }
      });
  }

}
